<template>
  <!-- 章节作业 -->
  <div class="uni-practice">
    <!-- 课程类型 -->
    <div class="box filter-box">
      <ul class="filter-list">
        <li class="item">
          <span class="tit">课程类型</span>
          <div class="con">
            <el-radio-group v-model="type">
              <el-radio class="radio" :label="1"
                >认定课程 ({{ selectlist.length || 0 }})</el-radio
              >
            </el-radio-group>
          </div>
        </li>
        <li class="item">
          <span class="tit">课程选择</span>
          <div class="con" style="margin-top: -5px">
            <el-button
              v-for="item in selectlist"
              class="course"
              :class="courseUuid == item.course_id ? 'active' : ''"
              size="mini"
              round
              :key="item.id"
              @click="courseSelect(item)"
              >{{ item.title }}</el-button
            >
          </div>
        </li>
      </ul>
    </div>

    <div class="content-box">
      <!-- 作业进度 -->
      <ul class="title-box">
        <li class="title">
          <span class="f18">作业进度</span>
          <span class="gray-light mal20"
            >每个章节的题做完才算作业完成。</span
          >
        </li>

        <li class="total">
          <div>
            <span class="gray-light mar10">作业完成度</span>
            <span class="f30 lighten-blue">{{ course_info.ratio || 0 }}%</span>
          </div>        
        </li>
      </ul>

      <!-- 章节列表 -->
      <ul class="head-box">
        <li class="item">课程名称</li>
        <li class="item">上次作业时间</li>
        <li class="item">做题情况</li>
        <li class="item">操作</li>
      </ul>

      <ComponentCollapse
        v-for="item in majorList"
        ref="component"
        :title="item.title"
        class="collapse-box"
        :key="item.id"
        :name="item.id"
        :activeNames="activeNames"
      >
        <div class="title-right" slot="title-right">
          <el-progress :percentage="item.ratio"></el-progress>
        </div>

        <ul
          slot="collapseContent"
          class="collapse-cell"
          v-for="course in item.node"
          :key="course.id"
        >
          <li class="item">
            <i
              class="iconfont icongouxuan primary"
              v-if="course.task_status == 2"
            ></i>
            <!-- 占位 -->
            <el-progress
              v-else
              style="vertical-align: middle; margin-right: 10px"
              :width="20"
              :strokeWidth="0"
              type="circle"
              :percentage="0"
              :show-text="false"
            ></el-progress>
            <span class="span tit">{{ course.title }}</span>
          </li>
          <li class="item">{{ course.last_time || "--" }}</li>
          <li class="item">
            <span v-if="course.task_num>0 && course.subject_total>0">已做：{{ course.fulfil_number || 0 }}/总题：{{ course.subject_total || 0 }}</span>
            <span v-else>--</span>
          </li>
          <li class="item">
            <template v-if="course.task_num > 0">
              <span :class="getCourseClass(course.task_status)">{{
                workStatus[course.task_status]
              }}</span>

              <el-button
                v-if="course.task_status === 0 && course.learn_status === 1 && course_info.is_hours_complete === 1"
                @click="jump('startPractice', course)"
                class="uni-link-btn"
                type="primary"
                icon="el-icon-video-play"
                >做作业</el-button>
              <el-button
                v-else-if="course.task_status === 0  && course_info.is_hours_complete === 0"
                @click="jump('startPractice', course)"
                class="uni-link-btn"
                type="primary"
                icon="el-icon-video-play"
                >做作业</el-button>
              <span
                v-else-if="course.learn_status === 0 && course_info.is_hours_complete === 1"
                style="background: #999 !important;"
                class="uni-link-btn"
              >未完成学习</span>
            </template>

            <div class="gray" v-else>无作业练习</div>
          </li>
        </ul>
      </ComponentCollapse>

      <ComponentEmpty tips title="暂无作业进度" v-if="majorList.length == 0" />

      <!-- 提示框 -->
      <ComponentDialog1
        icon="fail"
        title="需完成本章节的课程学习"
        :visible.sync="isDialogVisible"
        @cancel="isDialogVisible = !isDialogVisible"
        @confirm="dialogConfirm"
        cancelText="返回"
        confirmText="去学习"
      ></ComponentDialog1>
    </div>
  </div>
</template>

<script>
import ComponentCollapse from "@/components/componentCollapse";
import { getMyCourse, getWorkList, getHomeWork } from "@/api/basic";
export default {
  name: "uni-practice",
  components: {
    ComponentCollapse,
  },
  data() {
    return {
      type: 1,
      isDialogVisible: false,
      isStudyWork: false,
      courseUuid: this.$route.query.courseUuid,
      activeNames: [],
      selectlist: [],
      majorList: [],
      course_info: {},
      workStatus: ["未完成", "已完成"],
    };
  },
  created() {
    this.getCourses();
    this.getSections(this.courseUuid);
  },
  methods: {
    //课程选择列表请求
    async getCourses() {
      const params = {
        course_type: this.type,
        rate_type: 0,
      };
      const { result } = await getMyCourse(params);
      if (result) {
        this.selectlist = result;
      }
    },
    // 章节列表
    async getSections(course_id) {
      const params = {
        course_id: course_id,
      };
      const res = await getWorkList(params);
      if (res.code == 200) {
        const { course_info, list } = res.result;
        this.majorList = list;
        this.course_info = course_info;

        if (list.length > 0) {
          this.activeNames.push(list[0].id);
        }
      }
    },
    // 课程选择
    courseSelect(course) {
      this.activeNames = [];
      this.courseUuid = course.course_id;
      this.getSections(course.course_id);
    },
    // 获取课节状态class
    getCourseClass(type) {
      switch (type) {
        // case 2: //已完成
        // case 1: //已完成
        //   return "oringe";
        // case 0: //未完成
        //   return "primary";
        case 1: //已完成  
        return "green";
        case 0: //未完成
        return "oringe";
        default:
          break;
      }
    },
    // 页面跳转
    jump(name, course) {

      // 做作业
      const params = {
        course_id: course.course_id,
        section_id: course.id,
      };
      getHomeWork(params).then((res) => {
        if (res.code == 200) {
          if (res.result) {
            this.$router.push({
              name: "homeWork",
              query: params,
            });
          } else {
            this.isDialogVisible = true;
          }
        }
      });
    },
    // 去学习
    dialogConfirm() {
      this.$router.push({
        name: "subject",
        query: {
          id: this.courseUuid,
          type: 1,
        },
      });
    },
  },
};
</script>

<style lang="scss">
.collapse-box {
  .header {
    background: #f8f9fb;
  }
  .title-right {
    width: 180px;
  }
}
</style>
<style lang="scss" scoped>
.uni-practice {
  // padding: $sideMargin;
  padding-bottom: 0;
  min-height: $menuH;

  .filter-box {
    background: #fff;

    .tit {
      width: 100px;
      font-size: 16px;
      font-weight: 600;
    }

    .con {
      flex: 1;
    }

    .filter-list {
      .item {
        display: flex;
        border-bottom: 1px solid $grayBorder;
        padding: 20px;

        &:last-child {
          border: none;
        }
      }

      .course {
        border: 0;
        margin: 5px 10px 5px 0;

        &.active {
          @include fontColor("primary");
          @include bgColor("active-color");
          border-color: #c0cdff;
        }
      }
    }
  }

  .content-box {
    background: #fff;
    margin-top: 10px;
    padding: 20px;

    .title-box {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .total {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
    }

    .head-box {
      display: flex;
      height: 40px;
      line-height: 40px;
      @include bgColor("primary-lighten");
      color: #fff;
      margin-top: 25px;
      margin-bottom: 25px;

      .item {
        height: 100%;
        border-right: 1px solid #fff;
        flex: 1;
        text-align: center;

        &:nth-child(1) {
          flex: 2;
        }

        &:last-child {
          border-right: 0;
        }
      }
    }

    .collapse-cell {
      display: flex;
      align-items: center;
      padding: 20px 20px 20px 70px;

      .iconfont {
        vertical-align: middle;
        font-size: 20px;
        margin-right: 10px;
      }

      .item {
        flex: 1;
        text-align: center;
        &:nth-child(1) {
          text-align: left;
          flex: 2;
        }
      }

      .uni-link-btn {
        @include uni-link-btn(90px);
        margin-left: 40px;
      }
    }
  }
  .green{color: green;}
}
</style>
